import React, { useEffect, useState } from 'react';
import confetti from 'canvas-confetti';

const GoalAnimation = () => {
  const [visible, setVisible] = useState(true);
  
  useEffect(() => {
    // Disparar confetti quando o componente montar
    const duration = 5 * 1000;
    const animationEnd = Date.now() + duration;
    
    // Função para criar o efeito de confetti
    const randomInRange = (min, max) => {
      return Math.random() * (max - min) + min;
    };
    
    // Iniciar o confetti
    const confettiCanvas = document.createElement('canvas');
    confettiCanvas.style.position = 'fixed';
    confettiCanvas.style.top = '0';
    confettiCanvas.style.left = '0';
    confettiCanvas.style.width = '100%';
    confettiCanvas.style.height = '100%';
    confettiCanvas.style.zIndex = '999';
    confettiCanvas.style.pointerEvents = 'none';
    document.body.appendChild(confettiCanvas);
    
    const myConfetti = confetti.create(confettiCanvas, { 
      resize: true,
      useWorker: true
    });
    
    // Efeito de confetti
    const runAnimation = () => {
      const timeLeft = animationEnd - Date.now();
      
      if (timeLeft <= 0) {
        // Remover canvas quando terminar
        document.body.removeChild(confettiCanvas);
        return;
      }
      
      // Configurações para o confetti
      const particleCount = 50 * (timeLeft / duration);
      
      // Lançar confetti de diferentes ângulos
      myConfetti({
        particleCount,
        startVelocity: 30,
        spread: 360,
        origin: {
          x: Math.random(),
          y: Math.random() - 0.2
        },
        colors: ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'],
        shapes: ['circle', 'square'],
        ticks: 200,
        gravity: 1.2,
        scalar: 1.2,
        drift: 0
      });
      
      // Continuar animação
      requestAnimationFrame(runAnimation);
    };
    
    // Iniciar animação
    runAnimation();
    
    // Esconder a mensagem após alguns segundos
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 4000);
    
    // Limpar timers ao desmontar
    return () => {
      clearTimeout(hideTimer);
      if (document.body.contains(confettiCanvas)) {
        document.body.removeChild(confettiCanvas);
      }
    };
  }, []);
  
  if (!visible) return null;
  
  return (
    <div className="goal-animation">
      <div className="goal-animation-content">
        <h1>🎯 META ATINGIDA! 🎯</h1>
        <p>Parabéns! Você bateu sua meta mensal!</p>
      </div>
    </div>
  );
};

export default GoalAnimation;